import React from 'react';
import HomeLanding from '../../components/HomeLanding/HomeLanding';

const Home = () => {
  return <HomeLanding />;
};

export default Home;
